import { IAllSourceBooking } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { config } from "config";
const default_page_size = 15;

const initialState: IAllSourceBooking = {
  count: 0,
  blacklaneCount: 0,
  yeloCount: 0,
  bookings: [],
  booking: null,
  loading: true,
  current_filters: {},
  filters: { page: 1, page_size: default_page_size },
  refresh: 0,
  reset: 0,
  refreshLoader: false,
  completedRevenue: 0,
};


export const allSourceBookingSlice = createSlice({
  name: "smart",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<any>) => {
      state.loading = action.payload;
      state.refreshLoader = action.payload;
    },
    refresh: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
    },

    setPage: (state, action: PayloadAction<any>) => {
      const { page } = action.payload;
      state.filters.page = page;
      state.reset += 1;
      state.refreshLoader = true;
    },

    resetPage: (state, action: PayloadAction<any>) => {
      state.filters.page = 1;
    },
    setFilters: (state, action: PayloadAction<any>) => {
      const { data } = action.payload;
      state.filters = data;
      state.refreshLoader = true;
    },
    resetFilters: (state: any) => {
      state.reset += 1;
      state.refreshLoader = true;
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
    },
    setCurrentFilters: (state, action: PayloadAction<any>) => {

      state.current_filters = action.payload;
    },
    setBookings: (state, action) => {
      const { bookings, count, yeloCount, blacklaneCount } = action.payload;
      state.bookings = bookings;
      state.count = count;
      state.blacklaneCount = blacklaneCount;
      state.yeloCount = yeloCount;
      state.refreshLoader = false;
    },
    setBooking: (state, action) => {
      state.booking = action.payload;
    },
    setCompletedRevenue: (state, action: PayloadAction<any>) => {
      state.completedRevenue = action.payload;

    },

  },
});

const allSourceBookingReducer = allSourceBookingSlice.reducer;

export const allSourceBookingActions = allSourceBookingSlice.actions;
export default allSourceBookingReducer;
